import { render, staticRenderFns } from "./drawpig.vue?vue&type=template&id=5df63bd4&"
import script from "./drawpig.vue?vue&type=script&lang=js&"
export * from "./drawpig.vue?vue&type=script&lang=js&"
import style0 from "./drawpig.vue?vue&type=style&index=0&id=5df63bd4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports